// src/styles/tokens.js
// Central design token system — all colours, fonts, and spacing in one place

const T = {
  bg:          "#080C18",
  surface:     "#0F1623",
  surfaceHigh: "#182030",
  border:      "#1E2D44",
  borderHigh:  "#2A3F5F",

  accent:     "#00C6FF",
  accentDim:  "#0090BB",
  accentGlow: "rgba(0,198,255,0.12)",

  gold:    "#F5C842",
  goldDim: "rgba(245,200,66,0.12)",

  green:    "#0FE89A",
  greenDim: "rgba(15,232,154,0.12)",

  red:    "#FF4D6A",
  redDim: "rgba(255,77,106,0.12)",

  purple: "#A78BFA",

  textPrimary:   "#EEF2FF",
  textSecondary: "#7A8BA0",
  textMuted:     "#3D4F65",

  fontDisplay: "'DM Serif Display', Georgia, serif",
  fontBody:    "'DM Sans', system-ui, sans-serif",
  fontMono:    "'JetBrains Mono', monospace",
};

export default T;
